import styled from 'styled-components';
import { TableCell } from '@material-ui/core';

export const StyledTableCell = styled(TableCell)`
  font-size: 16px;
  color: #999;
  padding: 0 0 0.5rem 1rem;
`;
